import React from "react";
import { BillingSubscriptionPage } from "@/Components/account/BillingSubscriptionPage";
import CommonAppShell from "@/Components/CommonAppShell";

function BillingSubscriptions(): JSX.Element {
  
  return (
    <React.Fragment>
    <>
      <CommonAppShell sidebarLabel="billingSubscriptions" style={{ background: "#f2f4fa" }} padding="md" isSidebar={true}>
        <BillingSubscriptionPage key={Math.random()} />
      </CommonAppShell>
    </>
  </React.Fragment>
  );
}

export { BillingSubscriptions };
